import { FC, useCallback } from "react"
import classNames from "classnames"
import "./index.scss"

interface AvatarProps {
   firstName: string
   lastName: string
}

const Avatar: FC<AvatarProps> = ({ firstName, lastName }) => {
   const getInitials = useCallback(() => {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`
   }, [firstName, lastName])

   return (
      <div
         className={classNames("avatar", {
            "avatar--empty": firstName === "" && lastName === "",
         })}
      >
         <span className="avatar__initials">{getInitials()}</span>
      </div>
   )
}

export default Avatar
